import { Component } from '@angular/core';
import { ShopifyStorefrontService } from '../../services/shopify-storefront.service';
import { getBrandDataQuery } from '../../services/product-queries/get-brand-data';

@Component({
  selector: 'app-terms-of-service',
  imports: [],
  templateUrl: './terms-of-service.component.html',
  styleUrl: './terms-of-service.component.scss',
})
export class TermsOfServiceComponent {
  constructor(private data: ShopifyStorefrontService) {}
  brandData: any = null;
  ngOnInit() {
    this.data.genericQuery(getBrandDataQuery, {}).subscribe((res: any) => {
      this.brandData = res?.data?.shop;
      console.log('brandData', this.brandData);
    });
  }
}
